export default {"src":"/_next/static/media/message.ebcd0540.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};